type VisitorTier = 'SMALL' | 'MEDIUM' | 'LARGE';

/**
 * Determines which Visitor license tiers are eligible based on active user count.
 * Matches backend logic in visitorLocation/handler.js getEligibleVisitorTiers.
 *
 * Business rules:
 * - userCount ≤ 100: Small, Medium, Large all available
 * - 100 < userCount ≤ 500: Medium, Large only (Small ineligible)
 * - userCount > 500: Large only (Small, Medium ineligible)
 */
export const getEligibleVisitorTiers = (userCount: number): VisitorTier[] => {
  if (userCount <= 100) {
    return ['SMALL', 'MEDIUM', 'LARGE'];
  }
  if (userCount <= 500) {
    return ['MEDIUM', 'LARGE'];
  }
  return ['LARGE'];
};
